import {ChangeEvent, FC, FormEvent, useEffect, useState} from "react";
import Modal from "../../../../components/common/form/Modal";
import InputField from "../../../../components/common/form/InputField";
import {handleRTKQuery} from "../../../../helpers/utils/RtkQueryUtils";
import {useGetCollectorByIdQuery, useSearchCollectorQuery} from "../../collector/collector";
import {useCreateBulkLinkedAccountsMutation} from "../../linkedAccounts/linkedAccountsApi";
import Form from "../../../../components/common/form/Form";
import IconButton from "../../../../components/common/form/IconButton";
import {FaLink, FaSearch, FaTimes} from "react-icons/fa";
import CommonSelectorModal from "../../../../components/common/form/CommonSelectorModal";
import SelectField from "../../../../components/common/form/SelectField";
import {createOptionListForSelectTag} from "../../../../helpers/utils/Utils";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import {useGetEnumsQuery} from "../../../../app/globalApi";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import TextAreaField from "../../../../components/common/form/TextAreaField";
import CommonChosenInput from "../../../order/editor/Sections/CommonChosenInput";


interface props {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    isReadOnly?: boolean;
    highRishObj: any;
}

const AddLinkedAccountModal: FC<props> = ({show, setShow, isReadOnly, highRishObj}) => {

    const [linkedAccountData, setlinkedAccountData] = useState<any>({});
    const [selectedRowData, setSelectedRowData] = useState<any>({});
    const [createBulkLinked, createBulkLinkedApiResponse] = useCreateBulkLinkedAccountsMutation();
    const {data: enums} = useGetEnumsQuery("");
    const [linkedAccountNumbers, setLinkedAccountNumbers] = useState<any>([]);
    const [accountNumbers, setAccountNumbers] = useState([]);
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [showCollectorModal, setShowCollectorModal] = useState<boolean>(false);

    const {data: collectorData} = useGetCollectorByIdQuery(
        selectedRowData.id);

    useEffect(() => {
        if (highRishObj) {
            setlinkedAccountData((prevData: any) => ({
                ...prevData,
                collector: highRishObj.collectorName || "",
                collectorId: highRishObj.collectorId || "",
            }));
            const linkedAccounts = [
                highRishObj?.taxAccountNumber && {
                    label: highRishObj.taxAccountNumber,
                    value: highRishObj.taxAccountNumber
                },
                highRishObj?.appraisalDistrictNumber && {
                    label: highRishObj.appraisalDistrictNumber,
                    value: highRishObj.appraisalDistrictNumber
                },
                highRishObj?.translatedTaxAccountNumber && {
                    label: highRishObj.translatedTaxAccountNumber,
                    value: highRishObj.translatedTaxAccountNumber
                },
                highRishObj?.translatedAppraisalDistrictNumber && {
                    label: highRishObj.translatedAppraisalDistrictNumber,
                    value: highRishObj.translatedAppraisalDistrictNumber
                }
            ].filter(Boolean); // Remove undefined/null entries

            // Deduplicate based on the `value` property
            const uniqueLinkedAccounts = linkedAccounts.filter(
                (account: any, index: any, self: any) =>
                    self.findIndex((a: any) => a.value === account.value) === index
            );
            // Update state
            setLinkedAccountNumbers(uniqueLinkedAccounts);
        }
    }, [highRishObj]);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        let commonObj = {
            accountNumbers: accountNumbers.map((accountNumber: any) => accountNumber.value),
            linkedAccountNumbers: linkedAccountNumbers.map((linkedAccountNumber: any) => linkedAccountNumber.value),
            collector: {
                id: selectedRowData?.id || linkedAccountData?.collectorId || "",
                name: selectedRowData?.name || linkedAccountData?.collector || "",
            },
            category: linkedAccountData?.category?.value
        };

        const createOrUpdateCounty = async () => {
            return await createBulkLinked(commonObj).unwrap();
        };

        await handleRTKQuery(createOrUpdateCounty, (response: any) => {
             if (response?.success || response?.data?.success) {
                setlinkedAccountData({});
                setShow(false);
            }
        });
    }

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | {
        name: string;
        value: any
    } | ChangeEvent<HTMLTextAreaElement>) => {
        const {name, value} = "target" in e ? e.target : e;
        setlinkedAccountData({
            ...linkedAccountData,
            [name]: value,
        })
    }

    const handleOnClick = (e: any) => {
        e.preventDefault();

        setlinkedAccountData({
            ...linkedAccountData,
            collector: selectedRow.name
        })
        setShowCollectorModal(false)
    }

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
        },
        {
            label: "State",
            accessor: "state.stateAbbreviation",
        },
        {
            label: "County",
            accessor: "countyName",
        }
    ]

    const handleClearCollector = () => {
        setlinkedAccountData(() => ({
            ...linkedAccountData,
            collector: '',
        }));
    };


    return (
        <>
            <Modal
                title={"Add Linked Account"}
                show={show}
                setShow={setShow}
                className="w-3/6 justify-center item-center  bg-text-0 rounded-lg shadow-lg"
                fields={
                    <>
                        <Form onSubmit={handleSubmit} fields={<>
                            <div className="grid grid-cols-12">

                                <div className="col-span-12 grid grid-cols-12 gap-3 mt-2">
                                    <div className="col-span-3 sm:mt-2 lg:mt-0 flex">
                                        <label className="min-w-[100px]">*Account Numbers</label>
                                    </div>
                                    <div className="relative col-span-9 flex items-center gap-3">
                                        <div className="w-full">
                                            <CommonChosenInput
                                                placeholder={"Enter Account Numbers..."}
                                                state={accountNumbers}
                                                setState={setAccountNumbers}
                                                isRequired={false}/>
                                        </div>
                                    </div>
                                </div>

                                <InputField
                                    name="collector"
                                    label="Collector"
                                    onChange={handleOnChange}
                                    value={linkedAccountData.collector}
                                    placeholder="Enter Collector..."
                                    icon={<IconButton icon={<FaLink onClick={() => {
                                        if (selectedRow?.id) {
                                            window.open(`/collectors/${selectedRow.id}`, '_blank');
                                        }
                                    }}/>
                                    }
                                                      className={`text-sm  ${linkedAccountData?.collector ? 'text-highlight-4' : 'text-surface-4 cursor-default'
                                                      }`}/>}
                                    onClick={() => {
                                        setShowCollectorModal(true);
                                    }}
                                    className="cursor-pointer"
                                    inputIcon={
                                        linkedAccountData.collector ? (
                                            <FaTimes
                                                className="fa cursor-pointer text-highlight-0 absolute right-5 top-6"
                                                title="Clear"
                                                onClick={handleClearCollector}
                                            />
                                        ) : (
                                            <FaSearch
                                                className="fa cursor-pointer text-highlight-0 absolute right-5 top-6"
                                                title="show Modal"
                                                onClick={() => {
                                                    setShowCollectorModal(true);
                                                }}
                                            />
                                        )
                                    }
                                />

                                <SelectField
                                    placeholder='Select Category...'
                                    value={linkedAccountData?.category}
                                    options={createOptionListForSelectTag(enums?.["LinkCategory"], "value", "constant")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({name: "category", value: selectedOption})
                                    }}
                                    label={"Category"}
                                    required={true}
                                />

                                <div className="col-span-12 grid grid-cols-12 gap-3 mt-2">
                                    <div className="col-span-3 sm:mt-2 lg:mt-0 flex">
                                        <label className="min-w-[100px]">Linked Account Numbers</label>
                                    </div>

                                    <div className="relative col-span-9 flex items-center gap-3">
                                        <div className="w-full">
                                            <CommonChosenInput
                                                placeholder={"Enter Linked Account Numbers..."}
                                                state={linkedAccountNumbers}
                                                setState={setLinkedAccountNumbers}
                                                isRequired={false}/>
                                        </div>
                                    </div>
                                </div>

                                <TextAreaField
                                    name={"verified"}
                                    label="Note For Verified High Risk Acc"
                                    onChange={handleOnChange}
                                    value={linkedAccountData?.verified || ""}
                                    placeholder="Enter Note For Verified High Risk Acc..."
                                />


                            </div>

                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => {
                                                setShow(false)
                                            },
                                            type: "close",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Submit",
                                            type: "submit",
                                            isLoading: (createBulkLinkedApiResponse.isLoading),
                                        },
                                        buttonType: "button",

                                    }
                                ]}
                                align="end"
                                gap={2}
                            />

                        </>}
                        />

                    </>

                }
            />
            {showCollectorModal &&
                <CommonSelectorModal
                    title="Select Collector"
                    columns={columns}
                    data={useSearchCollectorQuery}
                    show={showCollectorModal}
                    onSubmit={handleOnClick}
                    customerFilter={{
                        sort: "name",
                        sortOrder: "ASCENDING"
                    }}
                    setShow={setShowCollectorModal}
                    setSelectedRow={setSelectedRow}
                />
            }
        </>
    )
}
export default AddLinkedAccountModal;